var React = require('react');

function AttentionArrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M39.0852 3.24933C39.4986 1.93198 38.7659 0.528874 37.4485 0.1154C36.1312 -0.298074 34.7281 0.43466 34.3146 1.75201L14.4517 65.036L4.71731 46.3459C4.07951 45.1213 2.56976 44.6457 1.34519 45.2835C0.120617 45.9213 -0.355058 47.431 0.282741 48.6556L13.9376 74.8729L40.1549 61.218C41.3794 60.5802 41.8551 59.0705 41.2173 57.8459C40.5795 56.6213 39.0698 56.1457 37.8452 56.7835L19.2412 66.473L39.0852 3.24933Z","fill":"white"}));
}

AttentionArrow.defaultProps = {"width":"42","height":"75","viewBox":"0 0 42 75","fill":"none"};

module.exports = AttentionArrow;

AttentionArrow.default = AttentionArrow;
